import React from "react";
import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";

function Education() {
  const educations = [
    {
      school: "Northeastern University",
      degree: "Master of Science in Computer Science",
      period: "Sep 2023 - Aug 2026",
      location: "Vancouver, Canada",
      gpa: 3.67,
      showCourses: true,
      courses: [
        "Data Structures and Algorithms",
        "Discrete Structures",
        "Web & Mobile Development",
        "Operating Systems",
        "Scalable Distributed Systems",
        "Database Management Systems",
      ]
    },
    {
      school: "Beijing University of Technology",
      degree: "Bachelor of Arts in English Language and Literature",
      period: "Sep 2019 - Jun 2023",
      location: "Beijing, China",
      minor: "Minor in Finance",
      showCourses: false,
      gpa: 3.79
    }
  ];

  return (
    <div className="education-container">
      <div className="education-timeline">
        {educations.map((edu, index) => (
          <div key={index} className="education-card">
            <div className="education-header">
              <h3>{edu.school}</h3>
              {edu.gpa && <div className="gpa-badge">GPA: {edu.gpa}</div>}
            </div>
            <p className="degree">{edu.degree}</p>
            {edu.minor && <p className="minor">{edu.minor}</p>}
            <div className="education-meta">
              <span><FaCalendarAlt /> {edu.period}</span>
              <span><FaMapMarkerAlt /> {edu.location}</span>
            </div>
            {edu.showCourses && (
              <div className="coursework">
                <h4>Coursework</h4>
                <div className="course-tags">
                  {edu.courses.map((course, idx) => (
                    <span key={idx} className="course-tag">{course}</span>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Education;